import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../pages/auth/services/auth.service';

export const reauthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  try {
    const initiated = sessionStorage.getItem('reauth_initiated');

    if (!authService.isLoggedIn()) {
      authService.urlToRedirectBack = state.url;
      return router.createUrlTree(['/login']);
    }

    if (initiated === 'true') {
      sessionStorage.removeItem('reauth_initiated');
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  } catch {
    authService.urlToRedirectBack = state.url;
    return router.createUrlTree(['/login']);
  }
};
